import { Box, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';

type Props = {
    bind: string;
    setName: (name: string) => void;
    setBind: (bind: string) => void;
};

export const ClientDetailsForm = ({ bind, setName, setBind }: Props) => {
    const { t } = useTranslation();
    const [toNormalize, setToNormalize] = useState<string>(bind);

    const re = /([^\s\w-]|)+/gi;
    useEffect(() => {
        const newBind = toNormalize
            .replace(re, '')
            .replace(/(\s+)/gi, ' ')
            .normalize('NFKD')
            .replaceAll(' ', '_');
        setBind(newBind);
    }, [toNormalize]);

    return (
        <Flex direction="row">
            <TextField
                sx={{ ml: '20px' }}
                placeholder={t('support.clientDetails.clientName')}
                onChange={(event) => setName(event.target.value)}
                required
            />
            <Flex direction="column" sx={{ ml: '20px' }}>
                <TextField
                    placeholder={t('support.clientDetails.clientBind')}
                    onChange={(event) => setToNormalize(event.target.value)}
                    required
                />
                <Flex
                    justifyContent="flex-start"
                    alignItems="baseline"
                    sx={{ pt: '10px', pl: '10px' }}
                >
                    <Box sx={{ mr: '10px' }}>
                        {t('support.clientDetails.urlPreview')}
                    </Box>
                    <Box>{`https:\\\\${bind}.manty.eu`}</Box>
                </Flex>
            </Flex>
        </Flex>
    );
};
